module.exports = __webpack_public_path__ + "static/img/catComponentes.d5d9c98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/catComponentes.svg
// module id = M209
// module chunks = 0